<template>
<v-menu 
        bottom 
        :left="!is_left"
        offset-y  
        v-model="show_context_menu"
    >

    <template v-slot:activator="{  }">
        
        <v-icon 
            size="25"
            v-on:click.stop="onClickContextMenu"
            v-show="hover || show_context_menu"
            style="margin-bottom: 15px;"
        >
            mdi-dots-vertical
        </v-icon>
        
    </template>

    <v-list>
        <v-list-item
        v-for="(item, index) in menu_items"
        :key="index"
        v-on:click="onClickItem(item)"
        >
        <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
    </v-list>
</v-menu>
</template>

<script>

export default {

    props: {
        message: {
            type: Object
        },

        hover: {
            type: Boolean
        },

        is_left: {
            type: Boolean
        }
    },

    data() {
        return {
            show_context_menu: false
        }
    },

    computed: {
        menu_items() 
        {
            if ( this.message.isText() || this.message.isLongPlainText() )
            {
                let ret = [
                    { 'text': 'Copy message text', 'cmd': 'copy' }, 
                    { 'text' : 'Message Details...', 'cmd' : 'details' },
                    { 'text' : 'Create Saved Message...', 'cmd' : 'saved-message' },
                ];

                if ( this.$rc.$state.isAuthActorSystemAdmin() )
                {
                    ret.push({ 'text': 'Edit...', 'cmd': 'edit' });
                }

                if ( this.message.isBulkMessage() )
                {
                    ret.push({ 'text': 'Change Outcome...', 'cmd': 'set-outcome' });
                }

                if ( this.$rc.$state.isAuthActorSystemAdmin() )
                {
                    ret.push({ 'text': 'Delete', 'cmd': 'delete' });
                }

                return ret;
            }

            if ( this.message.isBulkMessageOptEvent() )
            {
                let ret = [
                    { 'text': 'Opt Out/In', 'cmd': 'bulk_opt_in_out' },
                    { 'text' : 'Message Details...', 'cmd' : 'details' }
                ];

                if ( this.$rc.$state.isSystemsAdmin() )
                {
                    ret.push({ 'text': 'Delete', 'cmd': 'delete' });
                }

                return ret;
            }

            if ( this.message.isBlob() )
            {
                let ret = [
                    { 'text': 'Open in new tab...', 'cmd': 'open_in_new_tab' },
                    { 'text': 'Download', 'cmd': 'download' },
                    { 'text' : 'Message Details...', 'cmd' : 'details' } 
                ];

                if ( this.message.isBulkMessage() )
                {
                    ret.push({ 'text': 'Change Outcome...', 'cmd': 'set-outcome' });
                }

                if ( this.$rc.$state.isSystemsAdmin() )
                {
                    ret.push({ 'text': 'Delete', 'cmd': 'delete' });
                }

                return ret;
            }

            if ( this.message.isPaymentMessage() )
            {
                let ret = [
                    { 'text': 'View Payment...', 'cmd': 'view-payment' },
                    { 'text' : 'Message Details...', 'cmd' : 'details' }  
                ];

                if ( this.$rc.$state.isSystemsAdmin() )
                {
                    ret.push({ 'text': 'Delete', 'cmd': 'delete' });
                }

                return ret;
            }

            if ( this.message.isNote() )
            {
                return [
                    { 'text': 'Edit Note...', 'cmd': 'edit-note' }
                ];
            }

            if ( this.message.isScheduledMessage() )
            {
                return [
                    { 'text': 'Edit Scheduled Message...', 'cmd': 'edit-scheduled-message' },
                    { 'text': 'Delete Scheduled Message...', 'cmd': 'delete' },
                ];
            }

            let ret = [{ 'text' : 'Message Details...', 'cmd' : 'details' }];


            if ( this.message.isVCardMessage() )
            {
                // ensure the vcard has a phone number
                if ( this.message.getContentAsObject() && this.message.getContentAsObject().phone_numbers.length >= 1 )
                {
                    ret.push({ 'text': 'Add/Update Contact...', 'cmd': 'import_vcard' });
                }

                ret.push({ 'text': 'Download VCard', 'cmd': 'download_vcard' });
            }

            if ( this.$rc.$state.isSystemsAdmin() )
            {
                ret.push({ 'text': 'Delete', 'cmd': 'delete' });
            }

            return ret;
        }
    },

    methods: {
        onClickItem(item) 
        {
            if ( item.cmd === 'copy' )
            {
                const el = document.createElement('textarea');
                el.value = this.message.getContent();
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            }

            if ( item.cmd === 'saved-message' )
            {
                if ( this.message.data.content )
                {
                   this.$emit('create-saved-message', this.message.data.content);
                }
            }

            if ( item.cmd === 'open_in_new_tab' )
            {
                window.open(this.$rc.getBlobEndpoint(this.message.getBlobMetaData()),'_blank');
            }

            if ( item.cmd === 'download' )
            {
                window.open(this.$rc.getBlobEndpoint(this.message.getBlobMetaData())+"?download=true");
            }

            if ( item.cmd === 'download_vcard' )
            {
                window.open(this.$rc.blobURL(this.message.getContentAsObject().blob_id)+"?download=true");
            }

            if ( item.cmd === 'view-payment' )
            {
                let payment = JSON.parse(this.message.getContent());
                let payment_id = payment.payment_id;

                 this.$router.push({
                    'name': 'view-payment',
                    'params' : {
                        'payment_id' : payment_id,
                    },
                }).catch(e=>{}); // swallow any exception
            }

            if ( item.cmd === 'edit-note' )
            {
                this.$emit('edit-note', this.message.getId());
            }

            if ( item.cmd == 'bulk_opt_in_out' )
            {
                let bulk_opt_event = JSON.parse(this.message.getContent());
                let endpoint = bulk_opt_event.endpoint;
                let organization_id = bulk_opt_event.organization_id;

                this.$router.push({
                    'name': 'view-consent-details',
                    'params' : {
                        'organization_id' : organization_id,
                        'endpoint' : endpoint
                    }
                }).catch(e=>{}); // swallow any exception
            }

            if ( item.cmd == 'import_vcard' )
            {
                this.$emit('import-vcard', this.message);
            }

            if ( item.cmd == 'details' )
            {
                this.$emit('message-details',this.message.getId());
            }

            if ( item.cmd == 'edit') 
            {
                this.$emit('admin-edit-message',this.message);
            }

            if ( item.cmd == 'set-outcome' )
            {
                this.$emit('bulk-message-set-outcome', this.message);
            }

            if ( item.cmd == 'delete' )
            {
                this.$rc.confirm(
                    'Permanently Delete This Message?',
                    'Please confirm that you wish to permenantly delete this message.  This can not be undone.',
                    [
                        {'text': 'Cancel', 'value': 'cancel'},
                        {'text': 'Delete', 'value': 'confirm'},
                    ],
                
                    (response) => {
                        if (response != 'confirm') return;
                        
                        this.doDeleteMessage();
                    }
                );
            }

            if ( item.cmd == 'edit-scheduled-message' )
            {
                this.$emit('edit-scheduled-message',this.message);
            }
        },

        doDeleteMessage()
        {
            this.$rc.showSpinner();
                
            this.$rc.rest(
                'DELETE: /api/v1/admin/stored-message/:message_id',
            
                {
                    'message_id': this.message.getId(),
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to delete message');
                },
            );
        },

        onClickContextMenu()
        {
            this.show_context_menu = true;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>